export default {
  newApplicationVersion:
    'An updated version of Iryo Moshi is available. Click refresh to get it.',
  appOffline:
    'Connection with the server is down. The application might not be working.'
};
